import { Flex, Link, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { colors } from '../../../theme';

interface ProfileFormNavBtnProps {
	name: string;
	value?: string;
	nextRoute?: string;
}

export const ProfileFormNavBtn: FC<ProfileFormNavBtnProps> = ({
	name,
	value,
	nextRoute,
}) => {
	return (
		<Link
			as={nextRoute ? RouterLink : undefined}
			to={nextRoute || ''}
			_hover={{ textDecoration: 'none' }}>
			<Flex
				bg={'inherit'}
				transition={'all .1s ease-in'}
				borderRadius={'10px'}
				alignItems={'center'}
				padding={'10px 16px'}
				color={'blue.200'}
				_hover={{
					color: 'white',
					bg: 'blue.200',
					border: '1px solid #1C2959',
				}}
				border={`1px solid ${colors.dropBlue}`}
				justifyContent={'start'}
				w={'100%'}
				gap={'10px'}>
				<Flex
					flex={1}
					minW={0}
					direction={{ base: 'column', lg: 'row' }}
					alignItems={{ base: 'flex-start', lg: 'center' }}
					gap={{ base: '2px', lg: '10px' }}>
					<Text
						fontSize={{ base: value ? '12px' : '14px', lg: '14px' }}
						w={'auto'}
						minW={{ base: 'unset', lg: '70px' }}
						textAlign={'start'}
						color={'inherit'}>
						{name}
					</Text>
					<Text
						noOfLines={1}
						maxW={'full'}
						whiteSpace={'nowrap'}
						textOverflow={'ellipsis'}
						overflow={'hidden'}
						color={'inherit'}>
						{value}
					</Text>
				</Flex>
				{nextRoute ? (
					<ChevronRightIcon color={'inherit'} boxSize={6} />
				) : null}
			</Flex>
		</Link>
	);
};
